module.exports = __webpack_public_path__ + "img/piggy-bank.2e1b167a.png";